import styles from "./CreateBuildingsModal.module.scss";

interface InvalidBuildingsListProps {
    invalidBuildings: any[];
}

function InvalidBuildingsList({ invalidBuildings }: InvalidBuildingsListProps) {
    if (invalidBuildings.length === 0) return null;

    return (
        <div className={styles.invalidBuildingsContainer}>
            <div className={styles.invalidBuildingsHeader}>
                <span className={styles.descriptor}>Invalid Buildings ({invalidBuildings.length})</span>
            </div>
            <div className={styles.invalidBuildingsList}>
                {invalidBuildings.map((invalidBuilding, index) => (
                    <div key={crypto.randomUUID()} className={styles.invalidBuildingItem}>
                        <div className={styles.value}>{invalidBuilding.street_address}</div>
                        <div className={styles.descriptor}>
                            {invalidBuilding.city}, {invalidBuilding.state_province} {invalidBuilding.postal_zip_code}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default InvalidBuildingsList;
